import { FC, useCallback, useEffect, useState } from "react";

import { ChartSize } from "../../../../types/charts/size";
import { HorizontalBarChart } from "../../../Charts/HorizontalBarChart/HorizontalBarChart";
import { UiColors } from "../../../../config/ui/colors";
import { useWindowSize } from "../../../../hooks/useWindowSize";

import { INVESTMENT_RD_VS_GDP_CHART_DATA_KEYS } from "./InvestmentRDvsGDP.const";
import { InvestmentRDvsGDPProps } from "./InvestmentRDvsGDP.type";

const InvestmentRDvsGDP: FC<InvestmentRDvsGDPProps> = ({ data }) => {
	const { width } = useWindowSize();

	const [chartSize, setChartSize] = useState<ChartSize>("md");

	const [chartTickCount, setChartTickCount] = useState<number>(11);
	const [axisFontSize, setAxisFontSize] = useState(14);

	useEffect(() => {
		if (width < 475) {
			setChartSize("xs");
		} else if (width < 576) {
			setChartSize("sm");
		} else if (width < 960) {
			setChartSize("md");
		} else {
			setChartSize("lg");
		}
	}, [width]);

	useEffect(() => {
		switch (chartSize) {
			case "xs":
				setAxisFontSize(11);
				setChartTickCount(7);
				break;

			case "sm":
				setAxisFontSize(11);
				setChartTickCount(7);
				break;

			default:
				setAxisFontSize(16);
				setChartTickCount(7);
				break;
		}
	}, [chartSize]);

	const formatNumber = useCallback((number: number) => {
		return `${new Intl.NumberFormat("en").format(+number.toFixed(2))}%`;
	}, []);

	return (
		<HorizontalBarChart
			data={data}
			dataKeys={INVESTMENT_RD_VS_GDP_CHART_DATA_KEYS}
			barLabelFormatter={formatNumber}
			XAxisProps={{
				orientation: "top",
				domain: [0, 3],
				tickCount: chartTickCount,
				fontSize: axisFontSize,
			}}
			YAxisProps={{
				dataKey: "name",
				padding: { top: 15, bottom: 0 },
				fontSize: axisFontSize,
			}}
			barLabelPosition="right"
			barLabelColor={UiColors.black}
		/>
	);
};

export { InvestmentRDvsGDP };
